export default "__VITE_ASSET__b6lSEpe3__"